import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useFetch } from "./useFetch";
import { ILoginMethodResponse } from "../interfaces";

export const useLoginMethodApi = () => {
  const [notFound, setNotFound] = useState(false);
  const {
    apiCall: getLoginMethod,
    response,
    loading,
  } = useFetch("get");

  const refetch = useCallback(() => {
    getLoginMethod("ManageApi/LoginMethod", {}, undefined, (error) => {
      if (error?.response?.status === 404) {
        setNotFound(true);
        toast.error(error.response.data);
      }
    });
  }, [getLoginMethod]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: (response as ILoginMethodResponse | null) ?? null,
    loading,
    notFound,
    refetch,
  };
};
